/******************
* Floating Sidebar and Topbar
*******************/
if(typeof FN == 'undefined') FN = {};


FN.floatingSidebar = {
  visible: false,
  selector: '#sharing-sidebar',
  topThreshold: 0,
  resetTopThreshold: function(){
    FN.floatingSidebar.topThreshold = $('#post-detail h1').position().top;
  },
  init: function(){
    if($(FN.floatingSidebar.selector).length == 0) return;
    
    FN.floatingSidebar.resetTopThreshold();
    
    $(window).resize(function(){
      FN.floatingSidebar.resetTopThreshold();
    });

    $(window).scroll(function() {
      var scrollingPosition = $(window).scrollTop();
      FN.floatingSidebar.toggle(scrollingPosition > FN.floatingSidebar.topThreshold);
    });
  },
  
  toggle: function(show){
    if(show === FN.floatingSidebar.visible){ return; }
    var newFloatingSidebarPos = (show) ? '-6px' : '-70px';
    $(FN.floatingSidebar.selector).css({ right: newFloatingSidebarPos});
    FN.floatingSidebar.visible = show;
  }
};


FN.floatingTopbar = {
  fixed: false,
  selector: '.row-wrapper__sharing-topbar',
  topThreshold: 0,
  resetTopThreshold: function(){
    FN.floatingTopbar.topThreshold = $(FN.floatingTopbar.selector).position().top;
  },
  init: function(){
    if($(FN.floatingTopbar.selector).length == 0) return;
    
    FN.floatingTopbar.resetTopThreshold();
    
    $(window).resize(function(){
      FN.floatingTopbar.resetTopThreshold();
    });

    $(window).scroll(function() {
      var scrollingPosition = $(window).scrollTop();
      FN.floatingTopbar.toggle(scrollingPosition > FN.floatingTopbar.topThreshold);
    });
  },
  
  toggle: function(show){
    if(show === FN.floatingTopbar.fixed) return;
    if($(window).width() > 480) return;   // disable for non-mobile screens
    
    var newFloatingTopbarPos = 'inherit';
    var adjacentSiblingMarginTop = 76;
    if(show){
      newFloatingTopbarPos = 'fixed';
      adjacentSiblingMarginTop += 72;
    }

    $(FN.floatingTopbar.selector).css({ position: newFloatingTopbarPos});
    $('#post-detail').css({ "margin-top": adjacentSiblingMarginTop +'px' });
    FN.floatingTopbar.fixed = show;
  }
};




/***** Init */
$(function(){
  FN.floatingSidebar.init();
  FN.floatingTopbar.init();
});
